
import {
  computed,
  defineComponent,
  PropType,
  reactive,
  ref,
  toRefs
} from 'vue'

import { RouteRecord, RouteLocationNormalizedLoaded, useRouter, useRoute } from 'vue-router'

export interface NavigationItem {
  route: RouteLocationNormalizedLoaded;
  parent: RouteRecord;
}

export default defineComponent({
  name: 'NavigationItem',
  props: {
    value: {
      type: Object as PropType<NavigationItem>,
      required: true
    }
  },
  setup (props) {
    const $router = useRouter()
    const $route = useRoute()

    const state = reactive({
      active: ref(false),
      isActive: computed(() => {
        if ($route.name && props.value.route.name) {
          return ($route.name.toString().toLowerCase() === props.value.route.name.toString().toLowerCase())
        } else {
          return false
        }
      })
    })

    function handleClick (): void {
      if ($router.currentRoute.value.name && props.value.route.name) {
        if (
          $router.currentRoute.value.name.toString().toLowerCase() !==
          props.value.route.name.toString().toLowerCase()
        ) {
          if (props.value.parent.path) {
            $router.push(`${props.value.parent.path}${props.value.parent.path !== '/' ? '/' : ''}${props.value.route.path}`).catch(error => console.log(error))
          } else {
            $router.push(props.value.route.path).catch(error => console.log(error))
          }
        }
      }
    }

    return {
      ...toRefs(state),
      handleClick
    }
  }
})
